import type { IconData } from '@stacksjs/iconify-core'

export const sizingFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M1.5 19c0 4.926.161 8.571.338 11.083c.231 3.303 2.776 5.848 6.079 6.08c2.512.176 6.157.337 11.083.337s8.571-.161 11.083-.338c3.303-.231 5.848-2.776 6.08-6.079c.176-2.512.337-6.157.337-11.083s-.161-8.571-.338-11.083c-.231-3.303-2.776-5.848-6.079-6.08C27.571 1.662 23.926 1.5 19 1.5s-8.571.161-11.083.338c-3.303.231-5.848 2.776-6.08 6.079C1.662 10.429 1.5 14.074 1.5 19\"/><path fill=\"#2859c5\" d=\"M39 3a2 2 0 0 1 2-2h4a2 2 0 1 1 0 4v28a2 2 0 1 1 0 4h-4a2 2 0 1 1 0-4V5a2 2 0 0 1-2-2M3 39a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0h28a2 2 0 1 0 4 0v-4a2 2 0 1 0-4 0H5a2 2 0 0 0-2-2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sizingFlat
